module.exports = __webpack_public_path__ + "img/mic-button.37300e3f.svg";